import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";

export default function PaymentServicesEMILicenseCyprus() {

    return (
        <main className='main'>
            <IntroSection
                title="Payment Services & EMI License – Cyprus (Central Bank of Cyprus)"
                subtitle="Build Your FinTech, PSP, or EMI with EU Passporting Rights"
                description="Cyprus has become one of Europe’s most attractive jurisdictions for Payment Institutions (PIs) and Electronic Money Institutions (EMIs). Licensed by the Central Bank of Cyprus, these structures benefit from EU recognition and passporting rights, making Cyprus a top destination for fintech, remittance, wallet, and card businesses."
                badges={[
                    "Payment Processing",
                    "Merchant Acquiring",
                    "E-Wallets",
                    "IBAN Issuing",
                    "Prepaid Cards",
                    "Crypto Gateways"
                ]}
                buttonText="Request a Cyprus EMI Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/payment-services-EMI-license-cyrus-hero.png")}
                imageAlt="Cyprus Payment Services & EMI"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Cyprus for EMI & Payments?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "EU Passporting",
                                                text: "Operate across the entire EEA under PSD2/EMD."
                                            },
                                            {
                                                title: "Central Bank Supervision",
                                                text: "Strict but supportive regulator."
                                            },
                                            {
                                                title: "Lower Setup Costs vs Malta",
                                                text: "Same EU recognition, but more cost-effective."
                                            },
                                            {
                                                title: "Access to Banking & Card Schemes",
                                                text: "SEPA, SWIFT, Visa, and Mastercard."
                                            },
                                            {
                                                title: "FinTech Hub",
                                                text: "Growing ecosystem of EMIs, PSPs, and crypto-friendly services."
                                            },
                                            {
                                                title: "Gateway to MENA & Asia",
                                                text: "Strategically located between Europe, the Middle East, and Asia."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Payment Licenses in Cyprus"
                        blocks={[
                            {
                                title: "Payment Institution License (PI)",
                                items: [
                                    { text: "Process payments and remittances." },
                                    { text: "Merchant acquiring services." },
                                    { text: "Money transfer and alternative payments." },
                                    { text: "Capital Requirement: €125,000." }
                                ]
                            },
                            {
                                title: "Electronic Money Institution License (EMI)",
                                items: [
                                    { text: "Issue electronic money: wallets and prepaid cards." },
                                    { text: "Provide IBAN accounts and payment services." },
                                    { text: "Operate digital wallets and payment platforms." },
                                    { text: "Capital Requirement: €350,000." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Services Covered by a Cyprus EMI License"
                        item={
                            [
                                {
                                    title: "Multi-Currency Wallets",
                                    text: "Issue and manage digital wallets in multiple currencies."
                                },
                                {
                                    title: "IBAN Accounts",
                                    text: "Provide IBAN issuing and account services."
                                },
                                {
                                    title: "Card Programs",
                                    text: "Debit and prepaid card programs (Visa, Mastercard)."
                                },
                                {
                                    title: "Merchant Acquiring & Payment Processing",
                                    text: "Facilitate payments for merchants and clients."
                                },
                                {
                                    title: "Remittances & Cross-Border Transfers",
                                    text: "Handle international money transfers efficiently."
                                },
                                {
                                    title: "Crypto-to-Fiat Gateways",
                                    text: "Supported under AML/KYC compliance rules."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Cyprus EMI License'
                        services={
                            [
                                {
                                    title: "EEA-Wide Market Access",
                                    text: "Serve 30+ countries with a single license."
                                },
                                {
                                    title: "EU Recognition",
                                    text: "Regulated under PSD2 & EMD."
                                },
                                {
                                    title: "Banking Integration",
                                    text: "SEPA, SWIFT, and card schemes supported."
                                },
                                {
                                    title: "Investor Confidence",
                                    text: "EMIs attract venture capital and institutional partners."
                                },
                                {
                                    title: "Flexible Growth",
                                    text: "Start as PI and upgrade to EMI as business expands."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Select PI or EMI license."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish a Cyprus entity."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Prepare AML/KYC manuals, governance, and financial plan."
                                },
                                {
                                    title: "Submission to Central Bank",
                                    text: "Due diligence on shareholders and management."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically completed in 6–9 months."
                                },
                                {
                                    title: "Operational Setup",
                                    text: "Card issuing, PSP integrations, and compliance systems."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–9 months",
                            },
                            {
                                name: "Setup Costs",
                                description: "From €80,000+ (legal, compliance, audit, incorporation)",
                            },
                            {
                                name: "Capital Requirement",
                                description: "PI: €125,000 / EMI: €350,000",
                            },
                            {
                                name: "Annual Costs",
                                description: "Supervision, audits, compliance staff, regulatory fees",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in Cyprus EMI & PSP licensing" },
                                { text: "End-to-end service: company setup, license filing, compliance" },
                                { text: "Introductions to banks, card issuers, and processors" },
                                { text: "Support for IBAN issuing, wallet platforms, and crypto integration" },
                                { text: "Balanced advice: Cyprus vs Malta vs Offshore EMIs" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a regulated EU payment or e-money institution?"
                        description="Cyprus offers PI & EMI licenses with passporting rights across the EU, lower setup costs than Malta, and strong banking access."
                        buttonText="Book a Cyprus EMI License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What’s the difference between PI and EMI?",
        content: [
            { type: "answer", text: "PI = payment services only.\nEMI = payment services + issuance of electronic money (wallets, cards, IBAN)." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "€125k for PI, €350k for EMI." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–9 months on average." },
        ],
    },
    {
        question: "Can Cyprus EMI issue cards and IBANs?",
        content: [
            { type: "answer", text: "Yes — both are fully supported." },
        ],
    },
    {
        question: "Is crypto supported under EMI?",
        content: [
            { type: "answer", text: "Yes — crypto-to-fiat gateways are possible with AML/KYC compliance." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We licensed our EMI in Cyprus with Offshore Advisory. The Central Bank process was smooth, and now we operate across the EU.",
        author: "Richard K.",
        role: "FinTech Founder"
    },
    {
        quote: "Cyprus gave us an affordable way to enter EU payments. Offshore Advisory handled the license filing and PSP integrations.",
        author: "Sofia M.",
        role: "PSP Director"
    }
];
